import React, { useRef, useState } from 'react';
import { Link } from 'react-router-dom';

const items = [
	{
		id: 1,
		title: 'Rodent Rumble Social & Community Growth',
		role: 'Social Strategy & Marketing Execution',
		desc:
			'Owned and executed the full community and social media strategy for Rodent Rumble, building our internal content scheduling interface, content planning and creation, publishing, and performance across all major platforms. In under two months, drove rapid organic growth through platform-native content and event-driven activation, including a ~200% increase in Instagram followers, 180% growth in Instagram views, and multi-channel gains in reach, engagement, and player conversion.',
		highlights: [
			{
				title: 'Highlights',
				points: [
					'Built and owned the complete content calendar and publishing pipeline across Instagram, X, TikTok, YouTube, Discord, and Reddit',
					'Created all visual assets, short-form video, platform-specific copy, and tracked metrics for performance reporting',
					'Increased Instagram views from 0 to 14k in 28 days, reaching over 3k unique new accounts',
					'Significantly boosted YouTube growth with 8.7k views and 116% increase in watch time MoM',
				],
			},
		],
		image_link: '/images/rorumsocials.webp',
	},
	{
		id: 2,
		title: 'Discord Leaderboard Bot Creation',
		role: 'Community Systems & Technical Tooling – Design, Build, Deployment',
		desc:
			'Upon being tasked with finding a suitable Leaderboard bot for our Discord server, and hours of research and testing leading me to no viable existing options, I decided to create my own bot that fit our needs, start to finish in one night. This bot is a custom leaderboard system I built with Python and integrated into our Discord server, for Rodent Rumble\'s new Target Break mode. Allows players to submit speedrun times directly through Discord and compete in real time.',
		highlights: [
			{
				title: 'Highlights',
				points: [
					'Designed and developed a custom Python-based Discord bot from the ground up',
					'Enabled players to self-submit speedrun times, with moderator/developer approval automatically posting to live Leaderboard',
					'Created a competitive, event-driven player experience that encouraged repeat play and friendly community rivalry',
					'Successfully launched same-day as Target Break release, receiving strong community engagement and positive feedback',
				],
			},
		],
		image_link: '/images/leaderboard.png',
	},
	{
		id: 3,
		title: 'Rodent Rumble Growth Infrastructure & Conversion',
		role: 'CTR Optimization & Analytics',
		desc:
			'Designed and launched the official Rodent Rumble Linktree from scratch, transforming it into the primary landing and conversion hub for RodentRumble.com. The Linktree supported both online discovery and live event traffic, driving a 206% increase in views, a 200% increase in total clicks, and conversion spikes of up to 3200% for Instagram and over 1100% for Discord.',
		highlights: [
			{
				title: 'Highlights',
				points: [
					'Designed and launched the official Linktree used as the primary landing page for RodentRumble.com',
					'Integrated QR-based access for live events and public showcases',
					'Drove 450 clicks from 495 views, indicating exceptionally high click-through performance',
					'Supported a 137% increase in Steam wishlist clicks despite reduced placement during testing',
					'Drove a 3200% increase in Instagram profile click-through rate following launch',
				],
			},
		],
		image_link: '/images/linktree.png',
	},
	{
		id: 4,
		title: 'Live Event Showcasing & Partner Engagement',
		role: 'Live Events & Partner Activation',
		desc:
			'Initiated and led Rodent Rumble\'s live showcase at a public mall event in the Greater Seattle Area in partnership with Seattle Indies, representing a Canadian-based studio to a U.S. audience. Independently managed the booth, demos, and player engagement, translating online community strategy into in-person discovery and measurable post-event conversion.',
		highlights: [
			{
				title: 'Highlights',
				points: [
					'Coordinated and secured a live showcase partnership with Seattle Indies at a high-traffic mall event',
					'Ran the booth independently with two playable demo stations and promotional signage',
					'Drove event traffic to the official Linktree via QR code scans, targeting Steam wishlists during the holiday mall season',
					'Engaged directly with new players, explained gameplay, and guided hands-on demos',
				],
			},
		],
		image_link: '/images/rorumbooth.png',
	},
	{
		id: 5,
		title: 'AFK Arena Content Creator Camp',
		role: 'Creator Program Lead – Pitch, Launch, and Management',
		desc:
			'I pitched, launched, and led AFK Arena’s first formal Content Creator Camp, designed to scale high-quality user-generated content and strengthen relationships between creators, players, and the development team. From initial strategy to execution, I oversaw all aspects of the program: setting up the Discord server, scouting and onboarding, defining rules, providing individual support, and coordinating with our various internal departments as necessary. This program has increased our high-quality user-generated content output nearly tenfold, and strengthened the connection and recognition between creators and the community.',
		highlights: [
			{
				title: 'Highlights',
				points: [
					'Pitched and launched the Creator Camp from concept to execution, onboarding 40 creators in the first cohort',
					'Increased high-quality user-generated content output by over 900% within the first quarter',
					'Built and managed the program’s Discord infrastructure, guidelines, and creator support systems',
					'Secured both in-game and real-world rewards to incentivize participation and long-term engagement',
				],
			},
		],
		image_link: '/images/creatorcamp.webp',
	},
	{
		id: 6,
		title: 'AFK Arena & Journey Community Platforms',
		role: 'Head Moderator & Community Manager',
		desc:
			'I manage our large-scale online communities across Reddit and Discord, focused on maintaining a positive, inclusive, and healthy space for players of all experience levels to engage in. I built our Subreddit communities from the ground up, custom scripted YAML automation, and provide daily moderation support to our users as necessary. Head overseer of our Moderation Team and acting as the bridge between our mods/players and the official side.',
		highlights: [
			{
				title: 'Reddit Highlights',
				points: [
					'Built r/AFKArena and r/AFKJourney from scratch, growing them to 263k and 92k members respectively',
					'Custom scripted YAML automation to streamline/expedite moderation tasks and improve user experience',
					'Update our weekly resources, guides, and FAQs to keep them current and relevant',
					'Collaborated with dev teams to gather and respond to player feedback and suggestions (more on this below)',
				],
			},
			{
				title: 'Discord Highlights',
				points: [
					'Lead our moderation team, distributing tasks and ensuring their compensation is distributed on time',
					'Compose and send out announcements, updates, and important information to our players',
					'Organized and ran community events, contests, Q&A sessions, and more',
					'Provide weekly sentiment analysis reports to the development team for discussion and implementation',
				],
			},
		],
		image_link: '/images/community.png',
	},
	{
		id: 7,
		title: 'AFK Arena & Journey Feedback Initiatives',
		role: 'Pitch, Research, Discussion, and Implementation',
		desc: 'Launched a new recurring public program for players to share their feedback and suggestions, and vote on each other\'s ideas. This not only allows us to gather valuable insights from our community, but allows us to see what the community views as highest priority while giving the community a shared voice that promotes discussion and development in a direction they are shaping.',
		highlights: [
			{
				title: 'Highlights',
				points: [
					'Pitched the idea to our team and secured approval for implementation',
					'Gathered and organized suggestions, with our top 10 most voted receiving a public response from the team',
					'Other top suggestions that didn\'t make the cut were still discussed and considered for future implementation',
				],
			},
		],
		image_link: '/images/mailbox.webp',
	},
	{
		id: 8,
		title: 'Technical Contributions & Support',
		role: 'Technical QA, Bug Reporting, and Code Review',
		desc: 'While not within my usual scope of work, I have contributed to our development team by providing technical QA support, bug reporting, and code review. Bug reporting topics from the community is something I do on a regular basis, but there have been instances where I know exactly what to fix in the source code due to my programming background in univerity.',
		highlights: [
			{
				title: 'Highlights',
				points: [
					'Set up and streamlined an environment to share bug reports from the community to our dev team',
					'Code reviewed and provided working solution adapted into published hotfix',
					'Data Analysis: CLV/LTV, ARPU/DAU, lifecycle optimization goals, social media trends and performance, etc',
				],
			},
		],
		image_link: '/images/code1.png',
	},
	{
		id: 9,
		title: 'Video Game SFX and Music Composition',
		role: 'Sound Designer, Engineer, and Music Composer',
		desc: 'I grew up playing music from a very young age, and while I haven\'t been able to pursue that in a professional setting yet, it\'s still something I\'m very passionate about, and would love to contribute towards, or at least explore further in a future role if given the opportunity. In university, I participated in a Game Jam where I made all of the SFX and composed three original tracks for the game.',
		highlights: [
			{
				title: 'Highlights',
				points: [
					'Created all SFX with a variety of tools and techniques, including digital audio workstations and field recordings',
					'Composed three original tracks for the game via MIDI keyboard and DAW',
					'Unfortunately, all of this content was lost due to extremely heartbreaking circumstances - can share details upon request',
				],
			},
		],
		image_link: '/images/music.png',
	},
];

function PortfolioCard({ item, setSelectedImage }) {
	const imgRef = useRef(null);
	const [imgWidth, setImgWidth] = useState(undefined);

	const handleImgLoad = () => {
		if (imgRef.current) {
			setImgWidth(imgRef.current.width);
		}
	};

	return (
		<div
			className="bg-black/60 rounded-xl shadow-lg p-4 flex flex-col items-center" // changed from bg-slate-800
			style={{
				width: imgWidth ? `${imgWidth}px` : 'auto',
				minWidth: 220,
				maxWidth: 400,
				marginLeft: 'auto',
				marginRight: 'auto',
			}}
		>
			<img
				ref={imgRef}
				src={item.image_link}
				alt={item.title}
				className="w-full object-contain rounded-lg mb-4 bg-black/60 cursor-pointer hover:opacity-80 transition-opacity" // changed from bg-slate-800
				onLoad={handleImgLoad}
				style={{ display: 'block' }}
				onClick={() => setSelectedImage(item.image_link)}
			/>
			<div className="w-full flex flex-col">
				<h2 className="text-xl font-bold text-white">{item.title}</h2>
				{item.role && (
					<p className="text-base font-semibold text-cyan-300">{item.role}</p>
				)}
				<p className="text-sm text-gray-200">{item.desc}</p>
				{item.highlights &&
					item.highlights.map((section, idx) => (
						<div key={idx} className="mt-2">
							<p className="font-semibold text-white mb-1 text-sm">
								{section.title}
							</p>
							<ul className="list-disc list-outside pl-6 text-gray-100 text-sm">
								{section.points.map((point, i) => (
									<li key={i}>{point}</li>
								))}
							</ul>
						</div>
					))}
			</div>
		</div>
	);
}

function Index() {
	const [selectedImage, setSelectedImage] = useState(null);
	const [zoomLevel, setZoomLevel] = useState(1);

	const handleCloseModal = () => {
		setSelectedImage(null);
		setZoomLevel(1);
	};

	const handleZoomIn = () => {
		setZoomLevel(prev => Math.min(prev + 0.5, 3));
	};

	const handleZoomOut = () => {
		setZoomLevel(prev => Math.max(prev - 0.5, 1));
	};

	return (
		<div className="px-2 py-8 min-h-screen">
			{/* Image Modal */}
			{selectedImage && (
				<div 
					className="fixed inset-0 bg-black/90 z-50 flex flex-col"
					onClick={handleCloseModal}
				>
					<button 
						className="absolute top-4 right-4 text-white text-4xl font-bold hover:text-gray-300 transition-colors z-10"
						onClick={handleCloseModal}
					>
						×
					</button>
					
					<div className="flex-1 overflow-auto flex items-start justify-center p-4 pt-16">
						<img 
							src={selectedImage} 
							alt="" 
							className="max-w-5xl max-h-[85vh] rounded-lg transition-transform duration-200"
							style={{ 
								transform: `scale(${zoomLevel})`,
								transformOrigin: 'top center'
							}}
							onClick={(e) => e.stopPropagation()}
						/>
					</div>
					
					<div className="sticky bottom-0 left-0 right-0 flex justify-center pb-4 pointer-events-none">
						<div className="flex gap-2 bg-black/60 rounded-lg p-2 pointer-events-auto">
							<button 
								className="text-white px-4 py-2 bg-white/20 hover:bg-white/30 rounded transition-colors font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
								onClick={(e) => {
									e.stopPropagation();
									handleZoomOut();
								}}
								disabled={zoomLevel <= 1}
							>
								−
							</button>
							<span className="text-white px-4 py-2 font-semibold">{Math.round(zoomLevel * 100)}%</span>
							<button 
								className="text-white px-4 py-2 bg-white/20 hover:bg-white/30 rounded transition-colors font-semibold disabled:opacity-50 disabled:cursor-not-allowed"
								onClick={(e) => {
									e.stopPropagation();
									handleZoomIn();
								}}
								disabled={zoomLevel >= 3}
							>
								+
							</button>
						</div>
					</div>
				</div>
			)}
			
			<div className="max-w-6xl mx-auto">
				<h1 className="text-4xl font-bold mb-10 text-center text-white">
					Portfolio
				</h1>
				{/* First six items: stacked, alternating image/text sides */}
				{items.slice(0, 6).map((item, idx) => (
					<div
						key={item.id}
						className={`flex flex-col md:flex-row ${
							idx % 2 === 1 ? 'md:flex-row-reverse' : ''
						} gap-8 mb-10 items-stretch`}
						style={{ minHeight: 350 }}
					>
						<div className="flex justify-center items-center w-full md:w-1/2">
							<img
								src={item.image_link}
								alt={item.title}
								className="w-full h-auto max-h-[95%] rounded-lg object-contain my-2 cursor-pointer hover:opacity-80 transition-opacity"
								style={{ display: 'block' }}
								onClick={() => setSelectedImage(item.image_link)}
							/>
						</div>
						<div className="flex flex-col gap-2 justify-center px-2 w-full md:w-1/2">
							<h2 className="text-2xl font-bold text-white">
								{item.title}
							</h2>
							{item.role && (
								<p className="text-lg font-semibold text-cyan-300">
									{item.role}
								</p>
							)}
							<p className="text-base text-gray-200">{item.desc}</p>
							{item.highlights &&
								item.highlights.map((section, idx2) => (
									<div key={idx2} className="mt-2">
										<p className="font-semibold text-white mb-1">
											{section.title}
										</p>
										<ul className="list-disc list-outside pl-6 text-gray-100">
											{section.points.map((point, i) => (
												<li key={i}>{point}</li>
											))}
										</ul>
									</div>
								))}
						</div>
					</div>
				))}
				{/* Remaining items: smaller cards in a grid */}
				<div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
					{items.slice(6).map((item) => (
						<PortfolioCard key={item.id} item={item} setSelectedImage={setSelectedImage} />
					))}
				</div>

				{/* Call to Action */}
				<div className="mt-16 mb-16 flex flex-col gap-4 text-center max-w-2xl mx-auto">
					<p className="text-2xl font-bold text-white">Interested in Working Together?</p>
					<p className="text-lg text-gray-200">
						<Link to="/contact" onClick={() => window.scrollTo(0, 0)} className="text-cyan-400 hover:text-cyan-300 underline font-semibold transition-colors duration-200">Let's connect</Link> and discuss how I can contribute to your team's success!
					</p>
				</div>

				{/* Testimonials Section */}
				<div className="mt-16">
					<h2 className="text-3xl font-bold text-center text-white mb-4">
						Testimonials - Coming Soon
					</h2>
					<div className="max-w-xl mx-auto bg-black/60 rounded-lg p-6 shadow text-gray-200 text-center text-base">
                        This section will feature testimonials from collaborators and cohorts. I’m currently gathering individuals' permissions to ensure their comfort with their words and identities being shared here.
                        <br />
                        In the meantime, feel free to reach out to me directly if you’d like a copy of my Letter of Recommendation from a supervisor at Lilith Games.
                    </div>
				</div>
			</div>
		</div>
	);
}

export default Index;
